/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const StyledLink = styled(RouterLink)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
}));

const Link = React.forwardRef(({ to, children, ...other }, ref) => {
  const theme = useTheme();

  return (
    <StyledLink ref={ref} theme={theme} to={to} {...other}>
      {children}
    </StyledLink>
  );
});

Link.displayName = 'Link';

export default Link;

Link.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
};
